import request from '@/utils/request'

/**
 * 绑定员工信息
 * @param {Object} data 请求参数
 * @returns {Promise} 返回Promise对象
 */
export function bindingStaff(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/addStaffStepBinding/binding',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}